import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Checkbox from '../../../../components/checkbox'
import { FormattedMessage } from 'react-intl'
import { unitPrice } from '../../../../../../../utils/product'
import { BigButton } from '../../../../../../components/button'
import { useDispatch } from 'react-redux'
import {
    action_cart_select_all,
    action_cart_checkout,
    action_cart_change_paymethod,
} from '../../../../../../../store/actions/pages/cart'

import { klarna_create_session, klarna_get_params } from '../../../../../../../api'

import {
    TOGGLE_UI_LOGIN,
    TOOGLE_UI_ALERT
} from '../../../../../../../store/actions/ui'

import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import CheckoutConfirm from '../checkout-confirm'
import { useLogin } from '../../../../../../hooks/common'
import StayAlert from '../stay-alert'
import deeplink from '../../../../../../../utils/deeplink'
import { getSensorsUrl } from '../../../../../../utils/sensor'
import Cache from '../../../../../../../utils/cache'
import { SensorsTrack } from '../../../../../../utils/sensor'
import { fbInitialCheckout } from '../../../../../../../api/facebook-ctm-ads'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import TotalDiscountPopup from '../total-discount-popup'
import useCheckout from '../../hooks/checkout'
import QuickButton from '../quick-bottons'
import useCheckoutButton from '../../../checkout/hooks/checkout-button'
import PaymethodSelector from '../quick-bottons/paymethod-selector'
import PopupPrompt from '../../../../components/prompt'
import {testPhone, testZip} from '../../../../validator'
import FacebookEvents from '../../../../../../ads/events/facebook'
import FreeShipingTip, { FreeShippingLineTip, FreeShippingMinTip } from '../freeShippingTip'
import Cookie from "js-cookie";

const __support_types__ = [
    '1',
    '27',
    '28',
    '8',
    '30',
    '32',
]

export default props => {
    useStyles(classes)
    // summary={cart?.summary} saved={cart?.saved}
    const { count, selected, onCouponHandle, showStayAlert, setShowStayAlert, summaryMsg, summary, saved, selectedCard, onError, buttonPopups, payImages, checkoutButtonTip, underMsg } = props
    const global = useSelector(state => state.global)
    const history = useHistory()
    const isLogin = useLogin()
    const checkRef = useRef()
    const clickRef = useRef()
    const [showCheckoutConfirm, setShowCheckoutConfirm] = useState(false)
    const [showTotalPopup, setShowTotalPopup] = useState(false);
    const [renderError, setRenderError] = useState(false)
    const [showPaymethodList, setShowPaymethodList] = useState(false)

    const { orderTotal, subTotal, retailTotal, shippingPrice, originalShippingPrice, total } = summary;

    const { applyCheckout } = useCheckout();

    const {
        checkoutRefreshing,
        cart,
        // abTest,
        cardList
    } = useSelector(state => state.pageCart)

    const isMultiGroup = cart?.regionalCases?.length > 1
    let regionalCase={}
    if(cart?.regionalCases){
        regionalCase=cart?.regionalCases[0]
    }

    const { payMethod, payMethodList, shippingDetail } = cart

    const payMethodInfo = payMethodList?.find(p => p.id === payMethod)

    const {
        paying,
        pay
    } = useCheckoutButton({
        // klarnas, //todo
        payMethod: payMethodInfo,
        onError,
        selectedCard,
        isFastPayment: true
    })

    const loading = checkoutRefreshing || paying

    const payHandle = async e => {
        e.preventDefault()

        if(cart?.shippingDetail){
            if(!testZip(shippingDetail.zipCode ,shippingDetail.country?.value) || !testPhone(shippingDetail.phoneNumber, shippingDetail.country?.value)){
                onError({ type: 'validate_shipping' })
                return
            }
        }

        await dispatch(action_cart_checkout())
        const opts = {}
        if (payMethodInfo?.type === '27') {
            const response = await klarna_create_session({ payMethod: payMethodInfo.id })
            if (response?.code === 200 && response?.result) {
                const { client_token } = response.result
                window.Klarna.Payments.init({
                    client_token
                })
                const paramsResponse = await klarna_get_params({ payMethod: payMethodInfo.id })
                if (paramsResponse?.code === 200 && paramsResponse?.result) {
                    const params = paramsResponse?.result
                    opts.klarnas = params
                }
            }
        }
        pay(opts)

        SensorsTrack('CartAction', {
            action: `ClickPayNow_${payMethodInfo?.id}`
        })

        clickRef.current?.()
    }

    const abTest = 'A'

    const dispatch = useDispatch()

    const selectHandle = e => {
        e.preventDefault()
        dispatch(action_cart_select_all(!selected));
        setShowTotalPopup(false);
    }

    const clickHandle = async () => {
        SensorsTrack('CLICK_CHECKOUT', {  })
        if (!isLogin && !cart?.shippingDetail) {
            const utmSource=Cookie.get("utm_source")
            if(utmSource==='ig_g_order'){
                SensorsTrack('IG_CLICK_CHECKOUT', {  })
                guestHandle()
            }else{
                SensorsTrack('Checkout', { is_success: false, fail_reason: '游客确认', product_qty: cart.selectedProductCount, item_amount: Number(cart.summary?.usdItemTotal?.amount) || 0, pay_amount: Number(cart.summary?.usdSubTotal?.amount) || 0 })
                setShowCheckoutConfirm(true)
            }
        } else {
            SensorsTrack('USER_CLICK_CHECKOUT', {  })
            applyCheckout()
        }

        try {
            const productIds = cart?.regionalCases?.map?.(region => {
                return region.caseItems?.map(caseItem => {
                    return caseItem.shoppingCartProducts?.map(p => p.productId)
                })?.reduce((result, value) => {
                    result.push(...value)
                    return result
                }, [])
            })?.reduce((result, value) => {
                result.push(...value)
                return result
            }, [])
            fbInitialCheckout(productIds, orderTotal?.amount, orderTotal?.currency, count)

        } catch (error) {
            console.warn(error)
        }
    }

    const continueHandle = () => {
        SensorsTrack('CHECKOUT_CONTINUE_HANDLE', {  })
        dispatch({
            type: TOGGLE_UI_LOGIN,
            payload: {
                showLogin: true,
                eventType: "购买中",
                callBack: async () => {
                    // dispatch(action_fetch_cart())
                    setShowCheckoutConfirm(false)
                    applyCheckout()
                }
            }
        })
    }

    const guestHandle = async () => {
        SensorsTrack('CHECKOUT_GUEST_HANDLE', {  })
        const checkout = await dispatch(action_cart_checkout())
        if (checkout) {
            history.push('/cart/checkout')
        }
    }

    const deepLinkHandle = (deepLink, sensors) => {
        Cache.set('retention_type', cart?.retentionPromptWin?.type)
        setShowStayAlert(false)
        if (deepLink.type === 43) {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    resourcepage_title: "cart",
                    action: "凑单",
                    ...sensors
                })
            }
            history.push(getSensorsUrl(`/cart/collect-products?type=${deepLink?.params?.[0] || 0}`, sensors))
        } else if (deepLink.type === 44) {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    resourcepage_title: "cart",
                    action: "结算",
                    ...sensors
                })
            }
            clickHandle()
        } else if (deepLink.type === 45) {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    resourcepage_title: "cart",
                    action: "凑单",
                    ...sensors
                })
            }
            onCouponHandle()
        } else {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    resourcepage_title: "cart",
                    action: "离开购物车",
                    ...sensors
                })
            }
            const url = deeplink(deepLink, "msite")
            window.location.href = getSensorsUrl(url, sensors)
        }
    }

    const backHandle = (sensors) => {
        Cache.set('retention_type', cart?.retentionPromptWin?.type)
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("Popup_Stay", {
                resourcepage_title: "cart",
                action: "离开购物车",
                ...sensors
            })
        }
        setShowStayAlert(false)
        // if (document.referrer?.indexOf(global.config?.domain) < 1) {
        //     history.go(-5)
        // } else {
        //     history.goBack()
        // }

        history.goBack()
    }

    const closeHandle = (sensors) => {
        Cache.set('retention_type', cart?.retentionPromptWin?.type)
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("Popup_Stay", {
                resourcepage_title: "cart",
                action: "停留购物车",
                ...sensors
            })
        }
        setShowStayAlert(false)
    }

    const totalVerifyToogle = useMemo(() => {
        return count > 0 && summary?.display?.length > 0
    }, [count, summary]);

    const validDelPrice = useCallback((normalPrice, msrpPrice) => {
        if (normalPrice?.amount && msrpPrice?.amount) {
            let subAmount = Number(normalPrice?.amount);
            let retailAmount = Number(msrpPrice?.amount);
            return retailAmount > subAmount && retailAmount > 0;
        }
    }, []);

    const isShowDelPrice = useMemo(() => {
        return validDelPrice(orderTotal, total);
    }, [orderTotal, total]);

    const selectPayMethodHandle = useCallback(payMethod => {
        SensorsTrack('CartAction', {
            action: 'ClickPayMethod'
        })
        dispatch(action_cart_change_paymethod(payMethod))
    }, [])

    const onPaymethod = useCallback(() => {


        SensorsTrack('CartAction', {
            action: 'ClickMorePayMethod'
        })

        setShowPaymethodList(true)
    }, [])

    const renderErrorHandle = () => {
        setRenderError(true)
    }

    checkRef.current = () => {
        if(cart?.shippingDetail){
            if(!testZip(shippingDetail.zipCode ,shippingDetail.country?.value) || !testPhone(shippingDetail.phoneNumber, shippingDetail.country?.value)){
                onError({ type: 'validate_shipping' })
                return false
            }
        }

        return true
    }

    const checkShippingHandle = () => {
        return checkRef.current()
    }

    const showNewElement = abTest === 'A' && __support_types__.indexOf(payMethodInfo?.type) >= 0
    // let shipsFrom='Overseas'
    // if(cart?.regionalCases){
    //     shipsFrom=cart.regionalCases[0].shipsFrom
    // }

    clickRef.current = () => {
        try {
            const productIds = cart?.regionalCases?.map?.(region => {
                return region.caseItems?.map(caseItem => {
                    return caseItem.shoppingCartProducts?.map(p => p.productId)
                })?.reduce((result, value) => {
                    result.push(...value)
                    return result
                }, [])
            })?.reduce((result, value) => {
                result.push(...value)
                return result
            }, [])
    
            FacebookEvents.initiateCheckout({
                content_ids: productIds,
                currency: orderTotal?.currency,
                num_items: count,
                value: orderTotal?.amount
            })
        } catch (error) {
            
        }

        
    }


    const QuickPayButton = showNewElement ? <QuickButton
        payHandle={payHandle}
        paying={loading}
        country={cart?.country}
        onPaymethod={onPaymethod}
        onError={onError}
        orderTotal={orderTotal}
        selectedCard={selectedCard}
        onRenderError={renderErrorHandle}
        selectPayMethodHandle={selectPayMethodHandle}
        payMethodList={payMethodList}
        payMethodInfo={payMethodInfo}
        isFastPayment
        check={checkShippingHandle}
        clickHandle={clickRef.current}
        count={count} /> : null

    return <>
        <div className={classes.Container}>

            {
                !!buttonPopups && <PopupPrompt buttonPopups={buttonPopups} />
            }

            {/* {
                summaryMsg?.msg && <div className={classes.BootPromptContainer}>
                    <div className={classes.BootPrompt}>
                        <span dangerouslySetInnerHTML={{ __html: summaryMsg.msg }}></span>
                    </div>
                </div>
            } */}
            {/*
            {
                (cart.shippingMsg && cart.shippingMsg.msg && !cart.shippingMsg.shoppingCartHidden&&!underMsg?.msg && !isMultiGroup) &&
                <FreeShipingTip cart={cart} msg={cart.shippingMsg.msg} isBW={global?.config?.shortName === "bellewholesale"} clickFunc={
                    cart.shippingMsg?.deepLink ? (e, sensors) => {
                        Cache.remove("__progress_coupon_id")
                        history.push(getSensorsUrl(`/cart/collect-products?type=${shipsFrom==='US'?3:0}`, sensors))
                    } : undefined
                }/>
            }
            {
                underMsg?.msg && !isMultiGroup && <FreeShippingLineTip underMsg={underMsg?.msg}/>
            }
            */}
            {
                (!isMultiGroup && regionalCase &&regionalCase.shippingMsg && regionalCase.shippingMsg.msg && !regionalCase.shippingMsg.shoppingCartHidden&&!regionalCase.shippingMsg.freeMsg) &&
                <FreeShipingTip cart={cart} msg={regionalCase.shippingMsg.msg} isBW={global?.config?.shortName === "bellewholesale"} clickFunc={
                    regionalCase.shippingMsg?.deepLink ? (e, sensors) => {
                        Cache.remove("__progress_coupon_id")
                        history.push(getSensorsUrl(`/cart/collect-products?type=${regionalCase.shipsFrom==='US'?3:0}`, sensors))
                    } : undefined
                }/>
            }
            {
                !isMultiGroup && regionalCase?.shippingMsg?.msg && regionalCase.shippingMsg.freeMsg && <FreeShippingLineTip underMsg={regionalCase.shippingMsg.msg}/>
            }

            <div className={classes.QuickContainer}>
                {
                    QuickPayButton && !renderError && <div className={classes.Info}>
                        <div className={`${classes.TopPrice} ${shippingPrice?.amount > 0 && classes.noPadding}`}>
                            <div className={classes.SelectArea}>
                                <Checkbox selected={selected} onClick={selectHandle} />
                                <span className={classes.Label}>
                                    <FormattedMessage id="all" defaultMessage="All" />
                                </span>
                            </div>
                            <div className={classes.OrderTotal}>
                                <span className={classes.PriceToogle} onClick={() => {
                                        if (totalVerifyToogle) {
                                            setShowTotalPopup(state => !state);
                                            SensorsTrack('CartAction', { action: 'ClickAmountDetail' })
                                        }
                                    }}>
                                        <span className={`${classes.Value} ${!isShowDelPrice ? classes.Black : ""}`}>{unitPrice(orderTotal)}</span>
                                        {
                                            isShowDelPrice && <del className={classes.Label}>{total ? unitPrice(total) : ""}</del>
                                        }
                                        {
                                            totalVerifyToogle && <span className={classes.Details}>
                                                <FormattedMessage id="details" defaultMessage="Details"/>
                                                <Iconfont className={`${classes.Jt} ${showTotalPopup ? classes.Active : ""}`}>&#xe779;</Iconfont>
                                            </span>
                                        }
                                </span>
                            </div>
                        </div>
                        {
                            shippingPrice?.amount > 0 &&
                            <div className={classes.ShippingPrice}>
                                {`(`}
                                <FormattedMessage id="with_shipping_price"/>
                                {`: ${unitPrice(shippingPrice)})`}
                            </div>
                        }
                    </div>
                }

                <div className={classes.MultiButton}>
                    {
                        QuickPayButton && !renderError ? <div className={classes.Area}>
                            {
                                QuickPayButton
                            }
                        </div> : <div className={classes.Area}>
                            <div className={classes.LeftPrice}>
                                <div className={classes.SelectArea}>
                                    <Checkbox selected={selected} onClick={selectHandle} />
                                    <span className={classes.Label}>
                                        <FormattedMessage id="all" defaultMessage="All" />
                                    </span>
                                </div>
                                <div className={classes.OrderTotal}>
                                    <span className={classes.PriceToogle} onClick={() => {
                                        if (totalVerifyToogle) {
                                            setShowTotalPopup(state => !state);
                                            SensorsTrack('CartAction', { action: 'ClickAmountDetail' })
                                        }
                                    }}>
                                        <span className={`${classes.Value} ${!isShowDelPrice ? classes.Black : ""}`}>{unitPrice(orderTotal)}</span>

                                        {
                                            totalVerifyToogle && <Iconfont className={`${classes.Jt} ${showTotalPopup ? classes.Active : ""}`}>&#xe779;</Iconfont>
                                        }
                                    </span>

                                    <p>
                                        {
                                            isShowDelPrice && <del className={classes.Label}>{total ? unitPrice(total) : ""}</del>
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        QuickPayButton && !renderError && <div className={`${classes.Or} ${global.language === 'de'? classes.Small:''}`}>
                            <FormattedMessage id="or" defaultMessage={'Or'}/>
                        </div>
                    }

                    <div className={classes.Area}>
                        <BigButton onClick={clickHandle} className={classes.CheckoutButton} disabled={!(count > 0)} loading={loading}>
                            {
                                QuickPayButton && !renderError ? <FormattedMessage id="proceed_to_checkout" defaultMessage="Proceed to Checkout" />: <span style={{textTransform: 'uppercase'}}>
                                    <FormattedMessage id="checkout" defaultMessage="Checkout" />({count})
                                </span>
                            }
                            {
                                checkoutButtonTip?.tip && <FreeShippingMinTip checkoutButtonTip={checkoutButtonTip?.tip}/>
                            }
                        </BigButton>
                    </div>
                </div>
            </div>

            {
                !(QuickPayButton && !renderError) && payImages?.imageUrl && <div className={classes.PyImagesContainer}>
                    <div className={classes.PyImages} style={{ backgroundImage: `url(${payImages.imageUrl})` }}></div>
                </div>
            }
            
        </div>

        <CheckoutConfirm loading={checkoutRefreshing} onGuest={guestHandle} onContinue={continueHandle} show={showCheckoutConfirm} onClose={e => setShowCheckoutConfirm(false)} />

        {
            cart?.retentionPromptWin && <StayAlert
                serverTime={cart?.serverTime}
                retentionPromptWin={cart?.retentionPromptWin}
                onLeave={backHandle}
                onClose={closeHandle}
                onDeepLink={deepLinkHandle} show={showStayAlert} />
        }

        <TotalDiscountPopup show={showTotalPopup} onClose={() => setShowTotalPopup(false)} summary={summary} summaryMsg={summaryMsg} />

        <PaymethodSelector
            onError={onError}
            selectedCard={selectedCard}
            orderTotal={orderTotal}
            selectPayMethodHandle={selectPayMethodHandle}
            selectedPayMethod={payMethodInfo}
            payMethods={payMethodList}
            show={showPaymethodList}
            onClose={() => setShowPaymethodList(false)}
            paying={loading}
            pay={payHandle}
            country={cart?.country}
            check={checkShippingHandle}
            isFastPayment
        />

    </>
}